<template>
  <el-header class="model">
      <div class="header-left">
          <img src="../../assets/logo_zyw.png" class="header-left-icon">
          
      </div>
      <div class="header-right">
            <div class="right-content">
              <div @click="toUpdateCollapse" class="top">
                <img src="../../assets/icon_menu.png" style="height: 20px;">
              </div>
            </div>
      </div>
  </el-header>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      username: '',
      // isCollapse: false,
    }
  },
  computed: {
    getUsername: function () {
      let username = sessionStorage.getItem('username')
      return username
    },
    isCollapse() {
      return this.$store.state.isCollapse
    },
  },
  methods: {
    toUpdateCollapse(){
      let width =window.innerWidth
      console.log(width)
      if(width<700){
      
        this.$store.commit("updateCollapse", !this.isCollapse)
      }else{
        this.$store.commit("updateCollapse", !this.isCollapse)
      }
   
    },
    
  }
}
</script>

<style scoped>
.model {
    display:flex;
    flex-flow: row;
    padding: 0px;
    justify-content: flex-start;
}
.header-left {
    display: flex;
    flex-flow: column;
    width: 200px;
    height: 100px;
    align-items: flex-start;
    justify-content: center;
    background-color: #0c544f;
    border:0px;
}
.top {
  text-align: right;
  height: 30px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  margin-left: 30px;
}

.el-icon-set-up {
  color: #fff;
  text-align: left;
  cursor: pointer;
}
.header-left-icon {
    width: 144px;
    margin-left: 10px;
    height: 36px;
}
.header-left-label {
    width: 150px;
    color: #fff;
    margin-left: 10px;
    letter-spacing: 5px;
}
.header-right {
    /* width: 85%; */
    display: flex;
    flex: 1;
    flex-flow: row;
    height: 100px;
    align-items: center;
    justify-content: flex-start;
    background-color: #0c544f;
}
.right-slide{
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;
    display: flex;
}
.right-slide-icon {
    width: 40px;
    height: 40px;
    font-size: 12px;
}
.right-content {
    width:100%;
    height: 40px;
    display: flex;
    flex-direction: row-reverse;
    margin-right: 12px;
}
.drop {
    width: 142px;
    background-color:#00adb0;
}
.el-dropdown-link {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color:#ffffff;
    cursor: pointer;
}
.el-icon-arrow-down {
    font-size: 12px;
}
.dropmenu {
    background-color:#00adb0;
    width: 142px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue